import React from 'react';

const testimonials = [
  {
    name: '田中 美智子',
    age: '60代女性',
    location: '岡山市北区',
    service: '相続手続き',
    rating: 5,
    comment: '父の相続手続きでお世話になりました。複雑な手続きを分かりやすく説明していただき、安心してお任せできました。岡山先生の丁寧な対応に感謝しています。',
    image: 'https://public.readdy.ai/ai/img_res/ce4aa07f18ee5afc9901eaf2d911b2dc.jpg'
  },
  {
    name: '佐藤 健一',
    age: '40代男性',
    location: '倉敷市',
    service: '不動産登記',
    rating: 5,
    comment: 'マイホーム購入時の登記手続きをお願いしました。初回相談から完了まで、スムーズに進めていただき、とても満足しています。料金も明確で安心でした。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20in%20his%2040s%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20modern%20office%20or%20home%20setting%2C%20satisfied%20customer%20expression%2C%20no%20text%20visible&width=200&height=200&seq=testimonial2&orientation=squarish'
  },
  {
    name: '山田 由美',
    age: '50代女性',
    location: '岡山市南区',
    service: '債務整理',
    rating: 5,
    comment: '借金問題で悩んでいた時、倉敷先生に相談しました。親身になって話を聞いてくださり、最適な解決方法を提案していただきました。今は安心して生活できています。',
    image: 'https://readdy.ai/api/search-image?query=Relieved%20Japanese%20woman%20in%20her%2050s%2C%20gentle%20smile%2C%20casual%20clothing%2C%20comfortable%20home%20environment%2C%20peaceful%20and%20grateful%20expression%2C%20no%20text%20visible&width=200&height=200&seq=testimonial3&orientation=squarish'
  },
  {
    name: '鈴木 雅彦',
    age: '30代男性',
    location: '総社市',
    service: '会社設立',
    rating: 5,
    comment: '起業時の会社設立登記をお願いしました。津山先生には手続きの流れから必要書類まで詳しく教えていただき、スムーズに会社を設立することができました。',
    image: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20entrepreneur%20in%20his%2030s%2C%20enthusiastic%20smile%2C%20modern%20business%20attire%2C%20contemporary%20office%20setting%2C%20successful%20and%20confident%20expression%2C%20no%20text%20visible&width=200&height=200&seq=testimonial4&orientation=squarish'
  }
];

export const Testimonials: React.FC = () => {
  return (
    <section className="py-12 md:py-20 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">お客様の声</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            おかやま司法書士事務所をご利用いただいたお客様から、
            たくさんの喜びの声をいただいております。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-5 md:p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start mb-4 md:mb-6">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden mr-3 md:mr-4 flex-shrink-0">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-base md:text-lg font-semibold text-gray-900 truncate">{testimonial.name}</h3>
                  <p className="text-gray-600 text-xs md:text-sm">{testimonial.age} / {testimonial.location}</p>
                  <p className="text-blue-600 text-xs md:text-sm font-medium">{testimonial.service}</p>
                </div>
              </div>
              
              <div className="flex mb-3 md:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base md:text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 text-sm md:text-base leading-relaxed italic">
                「{testimonial.comment}」
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
